import { wrap } from '../wrap';
/*
 * target: []    分享到哪儿？示例：['wechat']
 */
function share(options) {
    window.console.log(options);
    var callback = options && (options.onShared || options.success);
    if (callback) {
        window.console.log('存在回调');
        setSharedCallback(callback);
    }
    wrap(function () {
        /*目前看孕育中没有shareToWeiChat这个方法,也不曾用过
            if (options && options.target && options.target[0] === 'wechat' && window.shareToWeiChat) {
                const share = window.shareToWeiChat;
                if (share) {
                    share(window.share.share_title,
                        window.share.share_content,
                        window.share.image_base64,
                        window.share.share_url);
                    return true;
                }
            */
        if (options && options.target) {
            //分享到不同的端wxsession,wxtimeline,qq,qzone,sina
            var sharePlatform = 'wxsession, wxtimeline, qq,qzone, sina';
            var target = options.target;
            if (window.navigator.userAgent.indexOf('iPhone OS') > -1) {
                window.installSharePlatform = function (data) {
                    sharePlatform = data;
                };
            }
            if (sharePlatform.indexOf(target) > -1) {
                window.console.log('target:' + target, '能分享的端', sharePlatform);
                if (window.Bridge && window.Bridge.postMessage) {
                    window.Bridge.postMessage({
                        method: 'shareSinglePlatform',
                        params: [target]
                    });
                    return true;
                }
                if (window.shareSinglePlatform) {
                    window.shareSinglePlatform(target);
                    return true;
                }
                if (window.android && window.android.shareSinglePlatform) {
                    window.android.shareSinglePlatform(target);
                    return true;
                }
            }
        }
        else {
            //if (window.webkit.messageHandlers && window.webkit.messageHandlers['shareAction']) {
            if (window.Bridge && window.Bridge.postMessage) {
                window.console.log('shareIos');
                //window.webkit.messageHandlers['shareAction'].postMessage([]);
                window.Bridge.postMessage({
                    method: 'shareAction' || 'actionShare',
                    params: []
                });
                return true;
            }
            const share = window.actionShare || window.shareAction;
            if (share) {
                share();
                return true;
            }
            if (window.android) {
                const shareAndroid = window.android.actionShare || window.android.shareAction;
                window.console.log('shareAndroid');
                shareAndroid();
                return true;
            }
        }
        return false;
    });
}
export default share;
